import { GlowEffect } from '@/components/ui/glow-effect'
import { Zap } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useSidebar } from '@/components/ui/sidebar'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/components/ui/tooltip'
import { useTranslation } from '@/hooks/useTranslation'

interface UpgradeButtonProps {
	onClick?: () => void
	href?: string
}

export function UpgradeButton({
	onClick,
	href = '/settings/billing',
}: UpgradeButtonProps) {
	const { t } = useTranslation()
	const { state } = useSidebar()
	const isCollapsed = state === 'collapsed'

	if (isCollapsed) {
		return (
			<div className="relative mb-6 flex justify-center">
				<GlowEffect
					colors={['#FF5733', '#33FF57', '#3357FF', '#F1C40F']}
					mode="colorShift"
					blur="soft"
					duration={3}
					scale={0.9}
				/>
				<Tooltip>
					<TooltipTrigger asChild>
						<Link
							to={href}
							onClick={onClick}
							className="relative inline-flex items-center justify-center rounded-md bg-zinc-950 p-2 text-zinc-50 outline outline-1 outline-[#fff2f21f] transition-all duration-300 hover:bg-zinc-900">
							<Zap className="h-4 w-4" />
						</Link>
					</TooltipTrigger>
					<TooltipContent side="right">
						<p>{t('upgradeButton.upgradeNow')}</p>
					</TooltipContent>
				</Tooltip>
			</div>
		)
	}

	return (
		<div className="relative mb-6">
			<GlowEffect
				colors={['#FF5733', '#33FF57', '#3357FF', '#F1C40F']}
				mode="colorShift"
				blur="soft"
				duration={3}
				scale={0.9}
			/>
			<Link
				to={href}
				onClick={onClick}
				className="relative inline-flex w-full items-center justify-center gap-2 rounded-md bg-zinc-950 px-3 py-2.5 text-sm font-medium text-zinc-50 outline outline-1 outline-[#fff2f21f] transition-all duration-300 hover:bg-zinc-900">
				<Zap className="h-4 w-4" />
				<span>{t('upgradeButton.upgradeNow')}</span>
			</Link>
		</div>
	)
}
